/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { LOGO_DXP, ToolbarProps } from '@squiz/sds';
import { DxpCapability } from 'apps/console-core/src/Constants/DxpCapabilities/defs/DxpCapability.defs';
import { ADMINISTRATION, AGENCY_ADMINISTRATION } from 'dxpAdministration-mf/Constants';
import { CONVERSATIONS } from 'dxpArtificialIntelligence-mf/Constants';
import { COMPONENT_SERVICE } from 'dxpComponentService-mf/Constants';
import { CONFIGURATION } from 'dxpConfiguration-mf/Constants';
import { DxpFrame, ToolbarTenantSwitcher } from 'dxpConsoleCore-mf/Components';
import { DXP_MENU_CORE_SECTION } from 'dxpConsoleCore-mf/Constants';
import { CUSTOMER_DATA_PLATFORM } from 'dxpCustomerDataPlatform-mf/Constants';
import { DIGITAL_ASSET_MANAGEMENT } from 'dxpDigitalAssetManagement-mf/Constants';
import {
  ADVANCED_FORMS,
  CONTENT_MANAGEMENT,
  DATA_SERVICES,
  INTEGRATIONS,
  SEARCH,
} from 'dxpInstanceManagement-mf/Constants';
import { MONITORING } from 'dxpMonitoring-mf/Constants';
import { OPTIMIZATION } from 'dxpOptimization-mf/Constants';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

/**
 * DXP Console - Host Application.
 */
export const ConsoleHost = (): JSX.Element => {
  // Get DXP capability sections
  const dxpCapabilities = [
    ADMINISTRATION,
    ADVANCED_FORMS,
    AGENCY_ADMINISTRATION,
    COMPONENT_SERVICE,
    CONFIGURATION,
    CONTENT_MANAGEMENT,
    CONVERSATIONS,
    CUSTOMER_DATA_PLATFORM,
    DATA_SERVICES,
    DIGITAL_ASSET_MANAGEMENT,
    INTEGRATIONS,
    MONITORING,
    OPTIMIZATION,
    SEARCH,
  ] as Array<DxpCapability>;

  const capabilitySections = dxpCapabilities
    .filter((capability) => capability !== undefined)
    .map((capability) => {
      return capability.menuSections;
    })
    .flat();

  // Set up IA for routing
  const applicationIA = [DXP_MENU_CORE_SECTION, ...capabilitySections];
  const toolbarProps: ToolbarProps = {
    clientName: <ToolbarTenantSwitcher />,
    logo: LOGO_DXP,
    menuSections: [],
    text: `Squiz DXP`,
  };

  return (
    <Router>
      <DxpFrame applicationIA={applicationIA} toolbarProps={toolbarProps} />
    </Router>
  );
};
